export const CREATE_EMAIL_RULE = '/api/emailrules/create'
export const OPERATIONS_EMAIL_RULE = '/api/emailrules/operations'
export const PARAMETERS_EMAIL_RULE = '/api/emailrules/parameters'
export const GET_EMAIL_RULE = '/api/emailrules/get'
export const GET_LIST_EMAIL_RULE = '/api/emailrules/list'
export const UPDATE_EMAIL_RULE = '/api/emailrules/update'
export const DELETE_EMAIL_RULE = '/api/emailrules/delete'



// WEBPACK FOOTER //
// ./src/api/email-rules/types.js